import { useMutation, useQuery, useQueryClient } from 'react-query';
import settings from 'settings';
import httpClient from 'services/httpClient';
import { clearAuthTokens, setAuthTokens } from 'services/authTokens';

type MeUser = {
  id: number;
  user_type: number;
  username: string;
};

export const useMe = (token?: string) => {
  return useQuery<MeUser>(
    'users/me',
    async () => {
      const url = `${settings.API_URL}/users/me`;
      const { data } = await httpClient.get(url);
      return data;
    },
    {
      retry: 0,
      onError: (err) => {
        console.log('auth', err);
        clearAuthTokens();
      },
      enabled: !!token,
    }
  );
};

const loginAction = async (params: { username: string; password: string }) => {
  const url = `${settings.API_URL}/auth/token/`;

  const { data } = await httpClient.post(url, params);
  return data;
};

export const useLogin = (options?: { onError?: (error: any) => void }) => {
  const queryClient = useQueryClient();

  return useMutation(loginAction, {
    onSettled: async (data) => {
      if (!data) return;

      setAuthTokens({ access: data.access, refresh: data.refresh });
      queryClient.invalidateQueries('users/me');
    },
    onError: options?.onError,
  });
};
